import HTTPClient from "./HTTPClient"

const USERDATA_KEY = "userData3"
const JWT_KEY = "jwToken"

export default class AuthService {

    static getToken() {
        return localStorage.getItem(JWT_KEY)
    }

    static async setToken(token: string) {
        console.log("setting jwToken")
        localStorage.setItem(JWT_KEY, token)
        AuthService.setUserData(await HTTPClient.get().getJSONResult("/api/users/me?populate=avatar,role,school"))
    }

    static removeToken() {
        console.log("removing jwToken")
        localStorage.removeItem(JWT_KEY)
    }

    static getUserData() {
        return JSON.parse(localStorage.getItem(USERDATA_KEY)!)
    }

    static getFirstName() {
        return this.getUserData()?.firstName || this.getUserData()?.username
    }

    static getLastName() {
        return this.getUserData()?.lastName || this.getUserData()?.username
    }

    static getLastNameWithSalutation() {
        let salutation = this.getUserData()?.salutation
        let value = this.getLastName()
        if (salutation) {
            value = salutation + " " + value
        }
        return value
    }

    static setUserData(userData: any) {
        console.log("setting userData")
        localStorage.setItem(USERDATA_KEY, JSON.stringify(userData))
    }

    static isLoggedIn() {
        return this.getToken() && this.getToken() !== "undefined" && this.getUserData()
    }

    static logOutWithoutReload() {
        localStorage.clear()
    }

    static logOut() {
        this.logOutWithoutReload()
        window.location.reload()
    }

    static getPrivileges() {
        if (!this.isLoggedIn()) {
            throw new Error("Not logged in")
        }
        // TODO return correct previliges
        return this.getUserData().role?.name
    }

    static hasRequiredPrevileges(requiredPrevileges: any) {
        try {
            let previleges = this.getPrivileges()
            // return requiredPrevileges.some((p: any) => {
            //     return previleges.indexOf(p) !== -1;
            // });
            return true
        } catch (error) {
            return false
        }
    }

    static getUserEmail() {
        return this.getUserData()["email"]
    }

    static getUserID() {
        return this.getUserData()["id"]
    }

    static getUsername() {
        return this.getUserData()["username"]
    }

    static getGrade() {
        return this.getUserData()["grade"]
    }

    static getLandingRoute() {
        return "/"
    }

    static getAvatarURL() {
        return this.getUserData()?.avatar?.url
    }

    static getRole() {
        return this.getUserData()?.role?.type
    }

    static isCurator() {
        return this.getUserData()?.role?.type === "curator"
    }

    static isRoleAuthenticated() {
        return this.getUserData()?.role?.type === "authenticated"
    }

    static isRoleTeacher() {
        return this.getUserData()?.role?.type === "teacher"
    }
}